import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'tokenField', 'hint']
  static values = { url: String, copyText: String }

  generate(event) {
    event.preventDefault();

    this.buttonTarget.disabled = true;

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Accept': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        this.tokenFieldTarget.value = data.token;
        this.buttonTarget.disabled = false;
        this.buttonTarget.textContent = this.copyTextValue;
        this.buttonTarget.dataset.targetValue = data.token;
        this.buttonTarget.dataset.action = 'click->copy-to-clipboard#copyTextValue';

        this.hintTarget.classList.remove('hidden');
      })
      .catch(error => {
        this.buttonTarget.disabled = false;
        console.error(error);
      })
  }
}
